import { Button, MagellanPopup } from 'components/atoms';
import IsBandSelectCard from 'components/molecules/card/is-band-select/IsBandSelectCard';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface IIsBandSelectPopupFormProps {
  trigger?: JSX.Element | ((isOpen: boolean) => JSX.Element) | undefined;
  onSelectIsBand?: (isBand: boolean | null, actions: PopupActions) => void;
  open?: boolean;
  initialIsBand?: boolean | null;
  displayMode?: boolean;
}

const IsBandSelectPopupForm = ({
  trigger,
  onSelectIsBand,
  open,
  initialIsBand = null,
  displayMode,
}: IIsBandSelectPopupFormProps) => {
  const popupRef = useRef<PopupActions | null>(null);
  const { t } = useTranslation();

  const [selectedIsBand, setSelectedIsBand] = useState<boolean | null>(null);

  return displayMode ? (
    <>{trigger}</>
  ) : (
    <Popup
      ref={popupRef}
      open={open}
      onOpen={() => {
        setSelectedIsBand(initialIsBand);
      }}
      onClose={() => {
        setSelectedIsBand(null);
      }}
      modal
      nested
      trigger={trigger}
    >
      <MagellanPopup>
        <MagellanPopup.Header>{t('input.label.isBand')}</MagellanPopup.Header>

        <div className="flex flex-col w-full max-w-96 overflow-auto h-[450px] [scrollbar-width:none]  gap-2">
          {[false, true].map((isBand) => (
            <IsBandSelectCard
              key={String(isBand)}
              isBand={isBand}
              isSelected={selectedIsBand === isBand}
              onClick={(newIsBand) =>
                setSelectedIsBand((prev) =>
                  prev === newIsBand ? null : newIsBand,
                )
              }
            />
          ))}
        </div>
        <div className="flex justify-between w-full">
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t('button.cancel')} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.submit}
            onClick={() =>
              popupRef.current &&
              onSelectIsBand &&
              onSelectIsBand(selectedIsBand, popupRef.current)
            }
          >
            <Button.Text text={t('button.save')} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default IsBandSelectPopupForm;
